/**
 @ngdoc directive
 @name communicationListPaginationHeader

 @description
 Sidebar with filters for Comms Management page

 @usage
 <communication-filter-sidebar
 tile-model="tileModel"
 common-label="ctrl.dataResponse.data.labels.common"
 object-label="ctrl.dataResponse.data.labels.commsManagement"
 filters="ctrl.filters"
 type-filters="ctrl.typeFilters"
 status-filters="ctrl.statusFilters"
 current-page="ctrl.currentPage"></communication-filter-sidebar>

 @param {string}  current-page                  - (passing current page number)parameter used to communication between communicationListPaginationHeader & communicationTile directives
 @param {integer}  page-size                    - (passing page size)parameter used to communication between communicationListPaginationHeader & communicationTile directives
 @param {string}  order-by                      - (passing order by option)parameter used to communication between communicationListPaginationHeader & communicationTile directives
 @param {string}  filtered-data-list-length     - (passing information about filtered data length)parameter used to communication between communicationListPaginationHeader & communicationTile directives
 @param {string}  start-from                    - (passing a number of start to start from for pagination)parameter used to communication between communicationListPaginationHeader & communicationTile directives
 @param {string}  query                         - (passing query string for filtering)parameter used to communication between communicationListPaginationHeader & communicationTile directives

 */

 (function() {
    'use strict';
    var communicationListPaginationHeader = function ($templateCache) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            bindToController: {
                //reminder [ '@':'one-way binding', '=':'two-way binding', '=?':'two-way binding optional', '&':'literal binding' ]
                idSuffix: "@",
                pagination: "=",
                searchFilter: "=",
                commonLabel: "=",
                ajaxInProgress: "="
            },
            controllerAs: "ctrl",
            scope: true,
            template: $templateCache.get('components/communicationListPaginationHeader.html'),
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
                var _this = this;

                _this.$onInit = function() {
                    //Listing keys for ordering function
                    _this.orderByList = [
                        {
                            name: "Date",
                            value: "dateCreated"
                        },
                        {
                            name: "Scheduled Date",
                            value: "scheduledDate"
                        }
                    ];

                    //Listing available page sizes for search tile pagination
                    _this.pageSizes = [
                        {
                            name: "10 results",
                            value: 10
                        },
                        {
                            name: "20 results",
                            value: 20
                        },
                        {
                            name: "30 results",
                            value: 30
                        },
                        {
                            name: "50 results",
                            value: 50
                        }
                    ];

                };
            }]
        };
    };

    communicationListPaginationHeader.$inject = ['$templateCache'];
    angular.module('app').directive('communicationListPaginationHeader', communicationListPaginationHeader);

}());